function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.354 10.648a.5.5 0 010 .706C11.286 11.42 9.676 13 7 13c-2.337 0-4.033-1.4-5-2.49V12a.5.5 0 01-1 0V9a.5.5 0 01.5-.5h3a.5.5 0 110 1H2.465C3.235 10.46 4.813 12 7 12c2.25 0 3.634-1.341 3.648-1.355a.5.5 0 01.706.003zM12.5 1.5a.5.5 0 00-.5.5v1.49C11.033 2.4 9.337 1 7 1 4.324 1 2.714 2.58 2.646 2.646a.5.5 0 10.707.709C3.365 3.341 4.75 2 7 2c2.188 0 3.765 1.54 4.535 2.5H9.5a.5.5 0 100 1h3A.5.5 0 0013 5V2a.5.5 0 00-.5-.5z",
  fill: "currentColor"
});

var SvgInUse = function SvgInUse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgInUse;